module.exports = __webpack_public_path__ + "static/media/badge.3c606d02.jpg";